var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkypeFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M18 6c2.07 2.04 2.85 4.89 2.36 7.55.41.72.64 1.56.64 2.45a5 5 0 01-5 5c-.89 0-1.73-.23-2.45-.64-2.66.49-5.51-.29-7.55-2.36-2.07-2.04-2.85-4.89-2.36-7.55C3.23 9.73 3 8.89 3 8a5 5 0 015-5c.89 0 1.73.23 2.45.64 2.66-.49 5.51.29 7.55 2.36zm-5.96 11.16c2.87 0 4.3-1.38 4.3-3.24 0-1.19-.56-2.46-2.73-2.95l-1.99-.44c-.76-.17-1.62-.4-1.62-1.11 0-.72.6-1.22 1.7-1.22 2.23 0 2.02 1.53 3.13 1.53.58 0 1.08-.34 1.08-.93 0-1.37-2.19-2.4-4.05-2.4-2.01 0-4.16.86-4.16 3.14 0 1.1.39 2.27 2.55 2.81l2.69.68c.81.2 1.01.65 1.01 1.07 0 .68-.68 1.35-1.91 1.35-2.41 0-2.08-1.85-3.37-1.85-.58 0-1 .4-1 .97 0 1.11 1.33 2.59 4.37 2.59z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkypeFill);
export default __webpack_public_path__ + "6c743e6792da358629329d2c5fb17d5c.svg";
export { ForwardRef as ReactComponent };